import { DateStringValue } from '@mantine/dates';
import dayjs from 'dayjs';

export const handleYearChange = (
  date: DateStringValue,
  setDate: (date: DateStringValue) => void,
  year: number
): void => {
  setDate(dayjs(date).year(year).startOf('month').format('YYYY-MM-DD'));
};
